// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qLQI","rootNoMargin":"styles_rootNoMargin__19J_Q"};